import React from "react";

export const Columns = (openCreateServiceOrder, openViewServiceOrder) => {
    return [
        {
            id: 'id',
            name: 'FOLIO',
            selector: row => row.id
        },
        {
            id: 'operator',
            name: 'OPERATOR',
            selector: row => `${row.operator?.first_name || ''} ${row.operator?.last_name || ''}`.trim() || 'N/A'
        },
        {
            id: 'trucksTrailers',
            name: 'TRUCKS & TRAILERS',
            selector: row => `${row.truck?.number || 'not selected'} / ${row.trailer?.number || 'not selected'}`
        },
        {
            id: 'description',
            name: 'DESCRIPTION',
            selector: row => row.description
        },
        {
            id: 'serviceOrder',
            name: 'SERVICE ORDER',
            selector: row => row.service_order?.internalId || (row.service_order_id ? `#${row.service_order_id}` : 'Pending')
        },
        {
            id: 'created_date',
            name: 'CREATE DATE',
            selector: row => row.created_at
        },
        {
            id: 'status',
            name: 'STATUS',
            selector: row => row.status?.name
        },
        {
            id: 'action',
            name: '',
            selector: row => (
                <div className="flex items-center gap-2 py-2">
                    {row.service_order_id ? (
                        <div className="flex flex-wrap items-center gap-2">
                            <span className="inline-flex items-center rounded-full bg-emerald-50 px-3 py-1 text-[11px] font-medium text-emerald-700 border border-emerald-200">
                                Linked to order {row.service_order?.internalId || `#${row.service_order_id}`}
                            </span>
                            <button
                                type="button"
                                onClick={() => openViewServiceOrder(row)}
                                className="inline-flex items-center gap-2 rounded-xl border border-emerald-300 px-3 py-2 text-[11px] font-medium text-emerald-700 transition-all hover:bg-emerald-50"
                            >
                                <span className="material-symbols-outlined text-sm">visibility</span>
                                View service order
                            </button>
                        </div>
                    ) : (
                        <button
                            type="button"
                            onClick={() => openCreateServiceOrder(row)}
                            className="inline-flex items-center gap-2 rounded-xl border border-cs-primary px-3 py-2 text-[11px] font-medium text-cs-primary transition-all hover:bg-cs-primary hover:text-white"
                        >
                            <span className="material-symbols-outlined text-sm">build</span>
                            Create service order
                        </button>
                    )}
                </div>
            ),
        },
    ];
};
